export default "__VITE_ASSET__BqX1LKiY__"